import { useState } from "react";

import ActivityView from "./ActivityView";
import ActivityEdit from "./ActivityEdit";

export default function ActivityItem({
    activity,
    control,
    onUpdate,
    onDelete,
    loadUserOptions
}) {

    const [editMode, setEditMode] = useState(false);

    if (!activity) return null;

    // =====================
    // HANDLERS
    // =====================

    const handleEdit = () => {
        setEditMode(true);
    };

    const handleCancelEdit = () => {
        setEditMode(false);
    };

    const handleSave = async (model) => {

        const result = await onUpdate?.(model);

        // اگر خطا نبود از edit خارج شو
        if (!result?.Message) {
            setEditMode(false);
        }

        return result;
    };

    const handleDelete = async () => {
        await onDelete?.(activity.ID);
    };

    // =====================
    // RENDER
    // =====================

    return (
        <div className="workitem-activity-item">

            {
                editMode ? (
                    <ActivityEdit
                        activity={activity}
                        control={control}
                        onSave={handleSave}
                        onCancel={handleCancelEdit}
                        loadUserOptions={loadUserOptions}
                    />
                ) : (
                    <ActivityView
                        activity={activity}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                )
            }

        </div>
    );
}